import React, {PureComponent as Component} from 'react';

import Field from "../../../../ui/template/Form/Field";
import FormManager from "../../../../ui/template/Form/FormManager";
import Alerts from "../../../../ui/template/Alert/Alerts";
import {MCbrowser} from "../../../Context/browserContext";
import commentInsertApi from "./Api/insertCommentApi";
import PropTypes from "prop-types";
import TextareaAutosize from 'react-textarea-autosize';
import Interface from "../../../../ui/template/Interface";


class  CommentInsert  extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;

        this.HtextChange = this.textChange.bind(this);
        this.HpressKey = this.pressKey.bind(this);

        this.handlePostUp = this.postUp.bind(this);
        this.state = {render:true};
        this.values = {  text:''  };

        this.form1=React.createRef();
        this.formAlerts=React.createRef();
        this.textEl=React.createRef();
        this.props=props;
    };

    textChange(e) {
        this.values.text =  e.target.value;
        return true;
    };

    async pressKey(e) {
        if(e.which === 13) {
            await this.postUp();
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    };

    async postUp() {
        if(!Interface.isEmptyString(this.values.text)) {
            let pageAlerts = this.context.page.pageAlerts;
            let l = await commentInsertApi(this.props.topicId, this.values.text, pageAlerts, this.formAlerts);
            if (l === true) {
                this.textEl.current.innerText = '';
                let page = this.context.page;
                let r = "topicComment" + this.props.topicId;
                page.dispatcher.run("route", r, "inserted");
                this.textEl.current.value="";
            }
        }
    }

    refresh() {
        let r=!this.state.render;
        this.setState({render:r});
    }

    componentDidMount() {

    }


    render() {

    return (
        <React.Fragment>
            <FormManager ref={this.form1} submit={this.handlePostUp}>
                <div className="p-3">
                    <Field   keyState="text">
                        <TextareaAutosize  ref={this.textEl}  className="form-control border-0 p-0 shadow-none" rows="1"
                                    placeholder="نظر خود را ثبت کنید ... "
                             onKeyDown={this.HpressKey}      onChange={this.HtextChange}  />
                    </Field>
                </div>
                <Alerts layout="relative" ref={this.formAlerts}/>
            </FormManager>
        </React.Fragment>
    )
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

CommentInsert.propTypes = {
    topicId:PropTypes.string,
};

CommentInsert.contextType = MCbrowser;

export default CommentInsert;
